/* eslint-disable */
export default {
  cancel: 'Peruuta',
  pmiChangeConfirmed: 'Muuta',
  pmiChangeConfirmTitle: 'Muutetaanko henkilökohtaisen tapaamisen asetuksia?',
  pmiChangeConfirmContext:
    'Näiden asetusten muuttaminen vaikuttaa kaikkiin tapaamisiin (mukaan lukien jo ajoitettuihin tapaamisiin), joissa käytetään henkilökohtaista tapaamistunnustasi tai nimeäsi',
  updatePassword: 'Päivitä salasana',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"pmiChangeConfirmed"@#@ @source: @#@"Change"@#@
// @key: @#@"pmiChangeConfirmTitle"@#@ @source: @#@"Change Personal Meeting settings?"@#@
// @key: @#@"pmiChangeConfirmContext"@#@ @source: @#@"Changing these settings will affect all meetings that use your personal meeting ID or name, including those you've already scheduled"@#@
// @key: @#@"updatePassword"@#@ @source: @#@"Update password"@#@
